<!-- Root element of PhotoSwipe. Must have class pswp. -->
<div class="pswp"
     tabindex="-1"
     role="dialog"
     aria-hidden="true"
     #photoswipeRef>
    <!-- Background of PhotoSwipe.
         It's a separate element, as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>
    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">
        <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
        <!-- don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
                @if (photoswipeTopbarTpl) {
                <ng-container *ngTemplateOutlet="photoswipeTopbarTpl" />
                } @else {
                <!--  Controls are self-explanatory. Order can be changed. -->
                <div class="pswp__counter"></div>
                @if (state) {
                <button class="pswp__button pswp__button--close"
                        title="Close (Esc)"
                        (click)="closeLightbox()"
                        [@itemAnimation]="true">
                    @if (photoswipeIconCloseTpl) {
                    <ng-container *ngTemplateOutlet="photoswipeIconCloseTpl" />
                    } @else {
                    <i class="icon-close"
                       aria-hidden="true"></i>
                    }
                </button>

                <button class="pswp__button pswp__button--zoom"
                        title="Zoom in/out"
                        tabindex="0"
                        (click)="photoswipe.zoomTo(0, {x: 0, y: 0}, 300)"
                        [@itemAnimation]="true">
                    @if (photoswipeIconZoomTpl) {
                    <ng-container *ngTemplateOutlet="photoswipeIconZoomTpl" />
                    } @else {
                    <i class="icon-zoom"
                       aria-hidden="true"></i>
                    }
                </button>
                }
                <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
                <!-- element will get class pswp__preloader--active when preloader is running -->
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                        </div>
                    </div>
                </div>
                }
            </div>
            @if (state) {
            <button class="pswp__button pswp__button--arrow--left"
                    title="Previous (arrow left)"
                    tabindex="0"
                    (click)="photoswipe.prev()"
                    [@itemAnimation]="true">
                @if (photoswipeIconPrevTpl) {
                <ng-container *ngTemplateOutlet="photoswipeIconPrevTpl" />
                } @else {
                <i class="icon-left"
                   aria-hidden="true"></i>
                }
            </button>

            <button class="pswp__button pswp__button--arrow--right"
                    title="Next (arrow right)"
                    (click)="photoswipe.next()"
                    tabindex="0"
                    [@itemAnimation]="true">
                @if (photoswipeIconNextTpl) {
                <ng-container *ngTemplateOutlet="photoswipeIconNextTpl" />
                } @else {
                <i class="icon-right"
                   aria-hidden="true"></i>
                }
            </button>
            }

            <div class="pswp__caption">
                <div class="pswp__caption__center"></div>
            </div>

            <!-- thumbs -->
            @if (photoswipeThumbnailsTpl) {
            <ng-container
                          *ngTemplateOutlet="photoswipeThumbnailsTpl; context: { $implicit: photoswipe, state: state }" />
            } @else if (state && photoswipe.items.length && photoswipe.items.length > 1) {
            <div class="pswp__thumbs custom-scrollbar"
                 [@itemAnimation]="photoswipe.items.length">
                @for (item of photoswipe.items; track $index) {
                @if (photoswipeThumbnailTpl) {
                <ng-container
                              *ngTemplateOutlet="photoswipeThumbnailTpl; context: { $implicit: item, index: $index, photoswipe: photoswipe }" />
                }
                }
            </div>
            }
        </div>
    </div>
</div>